/**
 * Search-param validators for TanStack Router routes. An invalid value falls back to the
 * default instead of erroring (docs/design/ia.md §1). A `validateSearch` must return every key
 * it owns (as undefined when invalid): the router merges the validated object over the parent
 * route's raw search, so an omitted key would keep the invalid value.
 */

export function optionalString(value: unknown): string | undefined {
  return typeof value === "string" && value !== "" ? value : undefined;
}

export function oneOf<const T extends readonly string[]>(
  options: T,
  value: unknown,
): T[number] | undefined {
  return typeof value === "string" && (options as readonly string[]).includes(value)
    ? (value as T[number])
    : undefined;
}

/** A positive integer (≥ 1); accepts numbers and numeric strings. */
export function positiveInt(value: unknown): number | undefined {
  const n = typeof value === "string" ? Number(value) : value;
  return typeof n === "number" && Number.isInteger(n) && n >= 1 ? n : undefined;
}

/** `true` only for `true` or "true". */
export function flag(value: unknown): true | undefined {
  return value === true || value === "true" ? true : undefined;
}
